import { Router } from '@funtech-int/rival';

import { PlayerContentType } from '@/scenarios/legacy-player/components/feature-player/types/content';
import { QueryParameter } from '@/shared/constants/queryParams';
import { playerRoute } from '@/scenarios/player/routes';
import { setQueryParams } from '@/scenarios/legacy-player/lib/set-query-params';

import { setReadyToPlay } from '../hooks/use-is-ready-to-play';
import { playingContentIdVar } from '../hooks/use-playing-content-id-var';
import { QueryParams } from '../types';

import { enrichPromoParamsIfNeed } from './enrich-promo-params-if-need';

interface SeriesInfo {
    seasonNumber?: number;
    episodeNumber: number;
}

interface StartPlayingContentProps {
    router: Router;
    contentId: string;
    seriesInfo?: SeriesInfo;
    contentType?: PlayerContentType;
    additionalQueryParams?: QueryParams;
    isNewPlayerEnabled: boolean;
}

/**
 * На время эксперимента используется для запуска и старого, и нового плеера
 * isNewPlayerEnabled – обязательный параметр
 * Выпил SAFTWEB-1728
 */
export const startPlaying = ({
    router,
    seriesInfo,
    additionalQueryParams,
    isNewPlayerEnabled,
    contentId,
    contentType,
}: StartPlayingContentProps) => {
    if (isNewPlayerEnabled && contentType !== PlayerContentType.CHANNEL) {
        return router.navigate({
            to: playerRoute({ contentId }),
        });
    }

    setReadyToPlay(false);
    playingContentIdVar.set(contentId);

    if (contentType === PlayerContentType.EPISODE) {
        if (seriesInfo?.seasonNumber) {
            const paramsToAdd: QueryParams = enrichPromoParamsIfNeed({
                [QueryParameter.WATCH]: '',
                [QueryParameter.SEASON_NUMBER]: String(seriesInfo.seasonNumber),
                [QueryParameter.EPISODE_NUMBER]: String(seriesInfo.episodeNumber),
                [QueryParameter.PLAYING_CONTENT_ID]: contentId,
                ...additionalQueryParams,
            });

            return setQueryParams({
                router,
                queryParams: paramsToAdd,
            });
        }
    }

    // если не найден сезон для эпизода, то устанавливаем хотя бы contentId
    if (contentType === PlayerContentType.FILM) {
        const paramsToAdd: QueryParams = enrichPromoParamsIfNeed({
            [QueryParameter.WATCH]: '',
            [QueryParameter.PLAYING_CONTENT_ID]: contentId,
            ...additionalQueryParams,
        });

        return setQueryParams({
            router,
            queryParams: paramsToAdd,
        });
    }

    if (contentType === PlayerContentType.CHANNEL) {
        return setQueryParams({
            router,
            queryParams: {
                [QueryParameter.OPENED_CHANNEL_ID]: contentId,
                ...additionalQueryParams,
            },
        });
    }

    if (contentType === PlayerContentType.SPORT_LIVE) {
        return setQueryParams({
            router,
            queryParams: {
                [QueryParameter.PLAYING_CONTENT_ID]: contentId,
                ...additionalQueryParams,
            },
        });
    }
};
